
export const SET_STOCKIST = "SET_STOCKIST_DATA";
export const CLEAR_STATE = "CLEAR_COMMON_STATE";
export const SET_STATE_DATA = "SET_STATE_DATA";
export const SET_ALL_STOCKISTS = "SET_ALL_STOCKISTS"

